import React from 'react';
import {Spinner} from 'react-bootstrap';

const LoadingPage = () => (
    <div className="d-flex align-items-center justify-content-center" style={{height:"100vh",width:"100vw"}}>
        <Spinner animation="border" variant="primary" />
    </div>
);

export default LoadingPage;